import React from "react";
import {MessageCircleDashed as MessageCircle} from 'lucide-react';

export default function WhatsAppButton() {
  const whatsappNumber = "5571991717353";
  const message = "Olá! Gostaria de solicitar um orçamento.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 animate-bounce hover:animate-none group"
      aria-label="Contato via WhatsApp"
    >
      <MessageCircle size={32} className="group-hover:rotate-12 transition-transform duration-300" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Solicite um orçamento!
      </span>
    </a>
  );
}
